import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './QuickActions.module.css';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: '➕',
      label: 'Agregar Producto',
      description: 'Crear nuevo producto en el catálogo',
      action: () => navigate('/admin/product-management')
    },
    {
      icon: '🎯',
      label: 'Crear Oferta',
      description: 'Configurar oferta especial',
      action: () => console.log('Crear oferta')
    },
    {
      icon: '📊',
      label: 'Ver Reportes',
      description: 'Generar reportes de ventas',
      action: () => console.log('Ver reportes')
    },
    {
      icon: '📦',
      label: 'Gestionar Inventario',
      description: 'Actualizar stock y productos',
      action: () => navigate('/admin/products')
    }
  ];

  return (
    <div className={styles.quickActions}>
      <h3>Acciones Rápidas</h3>
      <div className={styles.actionsGrid}>
        {actions.map((action, index) => (
          <button
            key={index}
            className={styles.actionCard}
            onClick={action.action}
          >
            <div className={styles.actionIcon}>{action.icon}</div>
            <div className={styles.actionContent}>
              <h4>{action.label}</h4>
              <p>{action.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;